import React from 'react'
import PrototypeArt from '../components/PrototypeArt'

function InternetArt() {

    return (
        <div>
            <PrototypeArt/>
        </div>
    )
}

export default InternetArt
